import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'How quickly can you respond to a repair request?',
      answer: 'We typically respond within 1-2 hours during business hours. For urgent repairs, we offer same-day service in most areas within our coverage zone. Emergency repairs for critical mobility equipment are prioritized to ensure your independence is restored as quickly as possible.'
    },
    {
      question: 'What areas do you service?',
      answer: 'We proudly serve the entire tri-state area including all five boroughs of New York City, Westchester County, Northern New Jersey (Bergen, Hudson, Essex, Passaic, and Union counties), and Fairfield County in Connecticut. We also service locations up to 100 miles from NYC.'
    },
    {
      question: 'What types of equipment do you repair?',
      answer: 'We specialize in repairing power wheelchairs, medical scooters, hospital beds, lift chairs, and patient lifts. Our certified technicians handle motor repairs, battery replacements, control system diagnostics, hydraulic maintenance, upholstery repair, and complete equipment overhauls.'
    },
    {
      question: 'How much do repairs typically cost?',
      answer: 'Repair costs vary depending on the equipment type and issue severity. There is no free evaluation — the evaluation fee depends on your location. Please note: we do not accept insurance of any kind. All services are private pay only. We accept cash, check, and major credit cards.'
    },
    {
      question: 'Do you accept insurance?',
      answer: 'No — Independence Medical Equipment does not accept insurance of any kind. We are a private-pay service only. All payments are made directly by the customer. Please note there is no free evaluation; the evaluation cost varies based on your location. We accept cash, check, and major credit cards. We are happy to provide an itemized receipt for your records.'
    },
    {
      question: 'Do you offer emergency repair services?',
      answer: 'Yes! We understand that mobility equipment failures can be urgent. We offer priority emergency service for critical repairs. Contact us immediately if you have an urgent need, and we will do our best to accommodate same-day service.'
    },
    {
      question: 'Is there a warranty on your repair work?',
      answer: 'Absolutely. All our repairs come with a comprehensive warranty covering parts and labor. The warranty period varies depending on the type of repair, but typically ranges from 90 days to one year. We stand behind our work and ensure your equipment operates safely and reliably.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq-section" className="py-20 bg-[#faf8f5]">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-gray-500 uppercase tracking-wider text-sm font-medium mb-4">
            COMMON QUESTIONS
          </p>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight">
            Fast Answers to<br />
            Your Repair Questions
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <h4 className="text-lg font-bold text-gray-900 pr-4">
                  {faq.question}
                </h4>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i 
                    className={`ri-${openIndex === index ? 'close' : 'add'}-line text-[#1e3a5f] text-2xl transition-transform duration-300`}
                  ></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}